export default "__VITE_ASSET__BAdnXuap__"